<template>
  <div class="contain-to-grid sticky" id="header-sec">
    <div class="container">
      <nav class="top-bar" data-options="sticky_on: large" data-topbar="" id="navigation" style="margin-left: 50px;">
        <ul class="title-area">
          <li class="name logo-brand">
            <h1><a href="index.html"><img alt="福州百步园艺" src="/skin/images/logo.png"></a></h1>
          </li>
          <li class="toggle-topbar menu-icon"><a @click="minMenu=true">Menu</a></li>
          <li class="mmenu-btn noDis"><a  @click="minMenu=true"><i class="fa fa-bars"></i></a></li>
        </ul>
        <section class="top-bar-section">
          <ul class="left" style="margin-left: 50px;">
            <li class='Lev1'> <a href="index.html" class="menu1">网站首页</a></li>
            <li class="Lev1  "> <a href="about.html" class="menu1">关于我们</a></li>
            <li class="Lev1  "> <a href="zwzl.html" class="menu1">植物租赁</a></li>
            <li class="Lev1  "> <a href="fwxm.html" class="menu1">服务项目</a></li>
            <li class="Lev1"> <a href="product.html" class="menu1">成功案例</a></li>
            <li class="Lev1"> <a href="article.html?articleCategoryId=5" class="menu1">新闻动态</a></li>
            <li class="Lev1"> <a href="article.html?articleCategoryId=6" class="menu1">养护知识</a></li>
            <li class="Lev1  "> <a href="contact.html" class="menu1">联系我们</a></li>
            <li class="Lev1  "> <a href="https://baibuzb.taobao.com" target="_blank" class="menu1">网络商城</a></li>
          </ul>
        </section>
      </nav>
    </div>
    <v-nav v-show="minMenu" @close="minMenu=false"></v-nav>
  </div>
</template>
<script>
import Vue from 'vue'
// import Jquery from 'jquery'
import VNav from './nav.vue'
export default {
  name: 'HeaderMenu',
  components: {
    VNav
  },
  data () {
    return {
      minMenu: false
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    // 创建构造器
    clickMenu () {
      const VNavComponent = Vue.extend(VNav)
      // 实例化组件并手动挂载到 body
      const instance = new VNavComponent().$mount()
      // 插入到 body 末尾
      document.body.appendChild(instance.$el)
    }
  }
}
</script>

<style scoped>
@media (max-width: 1024px) {
  .container {
    max-width: 100% !important;
  }
  #navigation .menu1{
    font-size: 1rem;
    font-weight: bolder;
    padding: 0 .2rem;
  }
  .mmenu-btn {
    display: block;
  }
}
@media (min-width: 1410px) {
    .container {
        max-width: 98%;
        width: 98%;
    }
    #navigation .menu1{
    font-size: 1.7rem;
    font-weight: bolder;
  }
}
#navigation .menu1:hover{
    color: #fff;
    background-color: #4ca734;
  }
  .contain-to-grid {
    overflow: hidden;
}
</style>
